import { Loader as Icon } from '@components/icons';
import { Spinner } from './Loader.styles';

export const Loader = () => {
  return (
    <Spinner>
      <Icon />
    </Spinner>
  );
};
